import React from 'react'

export const useTimestamp = () => {
  const [timestamp, setTimestamp] = React.useState(Date.now())

  const updateTimestamp = () => setTimestamp(Date.now())

  return [timestamp, updateTimestamp]
}
